import { render, staticRenderFns } from "./sign-method.vue?vue&type=template&id=4cdb03f0&scoped=true&"
import script from "./sign-method.vue?vue&type=script&lang=js&"
export * from "./sign-method.vue?vue&type=script&lang=js&"
import style0 from "./sign-method.vue?vue&type=style&index=0&id=4cdb03f0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cdb03f0",
  null
  
)

export default component.exports